import React from 'react';

const SearchBannerImage = ({ imgUrl, theme }) => {
  if (!imgUrl) {
    return null
  }

  return (
    <>
      <picture>
        <source
          media="(min-width: 1025px)"
          srcSet={
            "https://res.cloudinary.com/du5jifpgg/image/fetch/t_banner_w1440,q_auto,f_auto/" +
            imgUrl +
            " 1x, https://res.cloudinary.com/du5jifpgg/image/fetch/t_banner_w2880,q_auto,f_auto/" +
            imgUrl +
            " 2x"
          }
        />
        <source
          media="(min-width: 560px)"
          srcSet={
            "https://res.cloudinary.com/du5jifpgg/image/fetch/t_banner_w768,q_auto,f_auto/" +
            imgUrl +
            " 1x, https://res.cloudinary.com/du5jifpgg/image/fetch/t_banner_w1536,q_auto,f_auto/" +
            imgUrl +
            " 2x"
          }
        />
        <source
          media="(max-width: 560px)"
          srcSet={
            "https://res.cloudinary.com/du5jifpgg/image/upload/c_scale,t_banner_w360,q_auto,f_auto/" +
            imgUrl +
            " 1x, https://res.cloudinary.com/du5jifpgg/image/fetch/t_banner_w768,q_auto,f_auto/" +
            imgUrl +
            " 2x"
          }
        />
        <img
          src={
            "https://res.cloudinary.com/du5jifpgg/image/fetch/t_banner_w768,q_auto,f_auto/" +
            imgUrl
          }
          alt=""
          className="crtBanner-img"
        />
      </picture>
      <div
        className={`crtSearchInspirationBannerClipPath has-theme-${theme}`}
      ></div>
    </>
  );
};

export default SearchBannerImage;
